import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

export function ScreenHeader({
  title,
  right,
  onBack,
  className,
}: {
  title: string;
  right?: React.ReactNode;
  onBack?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "shrink-0 bg-background",
        "pt-safe px-6 pb-4 border-b border-ios-separator",
        className
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {onBack && (
            <button
              onClick={onBack}
              className="p-2 rounded-xl hover:bg-ios-surface-secondary"
              aria-label="Back"
            >
              <ChevronLeft size={20} className="text-white" />
            </button>
          )}
          <h1 className="ios-title-1 font-bold truncate">{title}</h1>
        </div>
        <div className="min-w-[48px] flex justify-end">{right}</div>
      </div>
    </div>
  );
}
